import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import 'lenis/dist/lenis.css';
import './App.css';
import './components/Navbar.css';
import './components/scrollExperience.css';
import SmoothScroll from './components/SmoothScroll';
import ScrollProgress from './components/ScrollProgress';
import HomePage from './components/HomePage';
import ServicesPage from './components/ServicesPage';
import AboutPage from './components/AboutPage';
import BlogPostPage from './components/BlogPostPage';
import CustomersPage from './components/CustomersPage';
import IndustriesPage from './components/IndustriesPage';
import IndustryDetailPage from './components/IndustryDetailPage';
import RiskAssessmentPage from './components/RiskAssessmentPage';
import SecurityMaturityPage from './components/SecurityMaturityPage';
import NistCsfAssessmentPage from './components/NistCsfAssessmentPage';
import NistAiRmfAssessmentPage from './components/NistAiRmfAssessmentPage';
import FreeToolsPage from './components/FreeToolsPage';
import PentestQuotePage from './components/PentestQuotePage';
import CertificationsPage from './components/CertificationsPage';
import LeadershipPage from './components/LeadershipPage';
import KnowledgeBasePage from './components/KnowledgeBasePage';
import SolutionGuidesPage from './components/SolutionGuidesPage';
import ThreatResearchPage from './components/ThreatResearchPage';
import ThreatResearchDetailPage from './components/ThreatResearchDetailPage';
import DetectionDispatchPage from './components/DetectionDispatchPage';
import DetectionDispatchDetailPage from './components/DetectionDispatchDetailPage';
import WebinarsPage from './components/WebinarsPage';
import ResourcesPage from './components/ResourcesPage';
import ContactPage from './components/ContactPage';
import ProductsPage from './components/ProductsPage';
import ProductDetailPage from './components/ProductDetailPage';
import CybersecurityPage from './components/CybersecurityPage';
import ManagedITPage from './components/ManagedITPage';
import DevelopmentPage from './components/DevelopmentPage';
import ServiceDetailPage from './components/ServiceDetailPage';
import ServiceCategoryPage from './components/ServiceCategoryPage';
import Chatbot from './components/Chatbot';
import CookieConsent from './components/CookieConsent';
import RegionTransition from './components/RegionTransition';
import InfoPage from './components/InfoPage';
import { infoPages } from './config/infoPages';
import { RegionProvider } from './context/RegionContext';
import { ContactModalProvider } from './context/ContactModalContext';
import ServiceRequestModal from './components/ServiceRequestModal';

function App() {
  return (
    <BrowserRouter>
      <RegionProvider>
        <ContactModalProvider>
        <SmoothScroll>
          <ScrollProgress />
          <div className="App">
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/category/:slug" element={<ServiceCategoryPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<Navigate to="/resources" replace />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/industries/:slug" element={<IndustryDetailPage />} />
            <Route path="/free-tools" element={<FreeToolsPage />} />
            <Route path="/risk-assessment" element={<RiskAssessmentPage />} />
            <Route path="/security-maturity-assessment" element={<SecurityMaturityPage />} />
            <Route path="/nist-csf-assessment" element={<NistCsfAssessmentPage />} />
            <Route path="/nist-ai-rmf-assessment" element={<NistAiRmfAssessmentPage />} />
            <Route path="/pentest-quote" element={<PentestQuotePage />} />
            <Route path="/certifications" element={<CertificationsPage />} />
            <Route path="/leadership" element={<LeadershipPage />} />
            <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
            <Route path="/solution-guides" element={<SolutionGuidesPage />} />
            <Route path="/threat-research" element={<ThreatResearchPage />} />
            <Route path="/threat-research/:slug" element={<ThreatResearchDetailPage />} />
            <Route path="/detection-dispatch" element={<DetectionDispatchPage />} />
            <Route path="/detection-dispatch/:slug" element={<DetectionDispatchDetailPage />} />
            <Route path="/webinars" element={<WebinarsPage />} />
            {/* Locations folded into the Contact page — redirect any old links. */}
            <Route path="/locations" element={<Navigate to="/contact" replace />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:slug" element={<ProductDetailPage />} />
            <Route path="/cybersecurity" element={<CybersecurityPage />} />
            <Route path="/managed-it" element={<ManagedITPage />} />
            <Route path="/development" element={<DevelopmentPage />} />
            {Object.keys(infoPages).map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<InfoPage />} />
            ))}
            </Routes>
            <Chatbot />
            <CookieConsent />
            <RegionTransition />
            <ServiceRequestModal />
          </div>
        </SmoothScroll>
        </ContactModalProvider>
      </RegionProvider>
    </BrowserRouter>
  );
}

export default App;
